import { cn } from "@repo/utils";
import DropdownTriggerIcon from "./dropdown-trigger-icon.js";
import type { IconProps } from "./dropdown.types.js";

type Props = {
  ref: React.Ref<HTMLDivElement>;
  trigger?: React.ReactNode;
  toggleOpen: () => void;
  isDDOpen: boolean;
  icon?: IconProps;
  className?: string;
  iconClassName?: string;
};

export const DropdownButton = ({
  ref,
  trigger,
  toggleOpen,
  isDDOpen,
  icon,
  className,
  iconClassName,
}: Props) => {
  return (
    <div
      ref={ref}
      data-allow-navigation
      onClick={(e) => {
        e.stopPropagation();
        toggleOpen();
      }}
      role="button"
      tabIndex={0}
      aria-label="Open menu"
      aria-expanded={isDDOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          toggleOpen();
        }
      }}
      className={cn("inline-flex cursor-pointer items-center justify-center", className)}
    >
      <DropdownTriggerIcon trigger={trigger} icon={icon} className={iconClassName} />
    </div>
  );
};
